import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { SITE } from "@/lib/site";

const links = [
  { href: "#what-is-coaching", label: "Coaching" },
  { href: "#obstacles", label: "Who I Help" },
  { href: "#services", label: "Services" },
  { href: "#about", label: "About" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 isolate transition-all duration-500 bg-brand-cream ${
        scrolled ? "border-b border-brand-sage/15 shadow-[0_4px_20px_rgba(47,66,80,0.04)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-24 md:h-28 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center">
          <img
            src={SITE.logoUrl}
            alt="Noa Grant Coaching — Parent and ADHD Coach"
            className="h-20 md:h-24 w-auto object-contain"
            style={{ mixBlendMode: "darken" }}
            data-testid="nav-logo-img"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="link-sweep text-sm font-medium text-brand-navy/80 hover:text-brand-coral transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href={SITE.calendly}
            target="_blank"
            rel="noreferrer noopener"
            data-testid="nav-cta-discovery-call"
            className="inline-flex items-center gap-2 rounded-full bg-brand-navy text-brand-cream px-6 py-3 text-sm font-medium tracking-wide hover:bg-brand-coral transition-colors duration-300"
          >
            Book a Discovery Call
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden rounded-full p-2 text-brand-navy hover:bg-brand-sage/10 transition"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-brand-sage/15 bg-brand-cream"
        >
          <nav className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-base font-medium text-brand-navy"
              >
                {l.label}
              </a>
            ))}
            <a
              href={SITE.calendly}
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-discovery-call"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-brand-navy text-brand-cream px-6 py-3 text-sm font-medium hover:bg-brand-coral transition-colors duration-300"
            >
              Book a Discovery Call
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
